// Widget entry point, loaded by customers via a single <script type="module">
// tag (F-030 embed). Registers the <storadar-map> custom element.
//
// This is the INITIAL bundle: it must stay under the 50KB gzip budget (F-030),
// so it deliberately does NOT import MapLibre — the map implementation lives in
// a lazy chunk that StoradarMap dynamically imports on boot (see
// component/StoradarMap and map/mapChunk).

import { StoradarMap } from "./component/StoradarMap";

export { StoradarMap };
export type { DataSource } from "./data/DataSource";
export type { PreviewPayload } from "./data/PreviewDataSource";
export { PreviewDataSource } from "./data/PreviewDataSource";
export { LiveDataSource } from "./data/LiveDataSource";

// Idempotent registration: guarded so a page that (accidentally) loads the
// bundle twice doesn't throw on a duplicate definition.
if (!customElements.get("storadar-map")) {
  customElements.define("storadar-map", StoradarMap);
}
